import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, addDoc, getDocs, query, orderBy, deleteDoc, doc } from 'firebase/firestore';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [name, setName] = useState('');
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  // Yönetici Yetkilendirme Durumları
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminEmail, setAdminEmail] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [showAdminModal, setShowAdminModal] = useState(false);

  // Kullanıcı Giriş Durumunu Dinle
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    });
    return () => unsubscribe();
  }, []);

  // Veritabanından Yorumları Çek
  const fetchReviews = async () => {
    try {
      const reviewsCollectionRef = collection(db, "reviews");
      const q = query(reviewsCollectionRef, orderBy("createdAt", "desc"));
      const data = await getDocs(q);
      const filteredData = data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setReviews(filteredData);
      setLoading(false);
    } catch (err) {
      console.error("Veriler çekilirken hata oluştu:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  // Yorum Ekle
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !comment.trim()) {
      alert("Lütfen adınızı ve yorumunuzu eksiksiz doldurun.");
      return;
    }

    try {
      const reviewsCollectionRef = collection(db, "reviews");
      await addDoc(reviewsCollectionRef, {
        name,
        rating: Number(rating),
        comment,
        date: new Date().toLocaleDateString('tr-TR'),
        createdAt: new Date()
      });

      setName('');
      setComment('');
      setRating(5);
      setSubmitted(true);
      fetchReviews();

      setTimeout(() => setSubmitted(false), 4000);
    } catch (err) {
      console.error("Yorum eklenirken hata oluştu:", err);
    }
  };

  // Yorum Sil (Sadece Admin İçin)
  const handleDelete = async (id) => {
    if (window.confirm("Bu yorumu silmek istediğinize emin misiniz?")) {
      try {
        await deleteDoc(doc(db, "reviews", id));
        fetchReviews();
      } catch (err) {
        console.error("Silme işleminde hata oluştu:", err);
        alert("Yorum silinemedi. Yetkiniz olmayabilir.");
      }
    }
  };

  // Admin Giriş İşlemi
  const handleAdminLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, adminEmail.trim(), adminPassword);
      setShowAdminModal(false);
      setAdminEmail('');
      setAdminPassword('');
      alert("Yönetici girişi başarılı.");
    } catch (err) {
      console.error("Giriş Hatası Detayı:", err.code, err.message);
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password') {
        alert("Hatalı e-posta veya şifre!");
      } else if (err.code === 'auth/user-not-found') {
        alert("Bu e-posta adresiyle kayıtlı kullanıcı bulunamadı!");
      } else if (err.code === 'auth/operation-not-allowed') {
        alert("Firebase panelinde Email/Password girişi aktifleştirilmemiş!");
      } else {
        alert("Giriş hatası: " + err.message);
      }
    }
  };

  // Admin Çıkış İşlemi
  const handleAdminLogout = async () => {
    await signOut(auth);
    alert("Yönetici oturumu kapatıldı.");
  };

  const renderStars = (count) => {
    return '★'.repeat(count) + '☆'.repeat(5 - count);
  };

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      boxSizing: 'border-box'
    }}>
      {/* BAŞLIK */}
      <div style={{ marginBottom: '40px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1a1a1a', marginBottom: '10px' }}>
          Müşteri Yorumları ve Değerlendirmeler
        </h2>
        <p style={{ color: '#666', fontSize: '1rem', maxWidth: '600px', margin: '0 auto' }}>
          Hizmetlerimiz hakkında görüşlerinizi paylaşabilir veya müşterilerimizin deneyimlerini okuyabilirsiniz.
        </p>
      </div>

      {/* İKİ KOLONLU DÜZEN */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '40px',
        alignItems: 'start'
      }}>
        
        {/* SOL: YORUM FORMU */}
        <div style={{
          backgroundColor: '#ffffff',
          padding: '30px',
          borderRadius: '16px',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.08)',
          border: '1px solid #eaeaea'
        }}>
          <h3 style={{ fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px', color: '#111' }}>
            Yorum ve Puan Ekle
          </h3>

          {submitted && (
            <div style={{
              backgroundColor: '#e6f4ea',
              color: '#137333',
              padding: '12px',
              borderRadius: '8px',
              marginBottom: '20px',
              fontSize: '0.9rem',
              textAlign: 'center'
            }}>
              Yorumunuz başarıyla kaydedildi!
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: '600', color: '#444', marginBottom: '6px' }}>
                Adınız Soyadınız
              </label>
              <input
                type="text"
                placeholder="Örn: Ali Yılmaz"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px 14px',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  fontSize: '0.95rem',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: '600', color: '#444', marginBottom: '6px' }}>
                Puanınız
              </label>
              <select
                value={rating}
                onChange={(e) => setRating(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 14px',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  fontSize: '0.95rem',
                  outline: 'none',
                  backgroundColor: '#fff',
                  cursor: 'pointer',
                  boxSizing: 'border-box'
                }}
              >
                <option value="5">★★★★★ (5/5 - Çok İyi)</option>
                <option value="4">★★★★☆ (4/5 - İyi)</option>
                <option value="3">★★★☆☆ (3/5 - Orta)</option>
                <option value="2">★★☆☆☆ (2/5 - Kötü)</option>
                <option value="1">★☆☆☆☆ (1/5 - Çok Kötü)</option>
              </select>
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: '600', color: '#444', marginBottom: '6px' }}>
                Yorumunuz
              </label>
              <textarea
                rows="4"
                placeholder="Hizmetimiz hakkında görüşlerinizi yazın..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px 14px',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  fontSize: '0.95rem',
                  outline: 'none',
                  resize: 'vertical',
                  boxSizing: 'border-box'
                }}
              ></textarea>
            </div>

            <button
              type="submit"
              style={{
                backgroundColor: '#2563eb',
                color: '#ffffff',
                padding: '14px',
                borderRadius: '8px',
                border: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease',
                marginTop: '8px'
              }}
            >
              Yorumu Gönder
            </button>
          </form>
        </div>

        {/* SAĞ: GELEN YORUMLAR LİSTESİ */}
        <div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            <h3 style={{ fontSize: '1.4rem', fontWeight: '600', color: '#111', margin: 0 }}>
              Gelen Yorumlar
            </h3>
            <span style={{
              backgroundColor: '#e2e8f0',
              color: '#475569',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '0.85rem',
              fontWeight: '600'
            }}>
              {reviews.length} Yorum
            </span>
          </div>

          {loading ? (
            <p style={{ color: '#666' }}>Yorumlar yükleniyor...</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', maxHeight: '550px', overflowY: 'auto', paddingRight: '6px' }}>
              {reviews.length === 0 ? (
                <div style={{
                  backgroundColor: '#ffffff',
                  padding: '30px',
                  borderRadius: '12px',
                  textAlign: 'center',
                  border: '1px solid #eaeaea',
                  color: '#666'
                }}>
                  Henüz yorum yapılmamış. İlk yorumu siz yapın!
                </div>
              ) : (
                reviews.map((rev) => (
                  <div key={rev.id} style={{
                    backgroundColor: '#ffffff',
                    padding: '20px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                    position: 'relative'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '50%',
                          backgroundColor: '#2563eb',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                          fontSize: '0.9rem'
                        }}>
                          {rev.name ? rev.name.charAt(0).toUpperCase() : 'U'}
                        </div>
                        <strong style={{ color: '#1f2937', fontSize: '1rem' }}>{rev.name}</strong>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{rev.date}</span>
                        
                        {/* SADECE YÖNETİCİYE GÖZÜKEN SİLME BUTONU */}
                        {isAdmin && (
                          <button
                            onClick={() => handleDelete(rev.id)}
                            style={{
                              backgroundColor: '#ef4444',
                              color: '#fff',
                              border: 'none',
                              borderRadius: '4px',
                              padding: '4px 8px',
                              fontSize: '0.75rem',
                              cursor: 'pointer',
                              fontWeight: '600'
                            }}
                          >
                            Sil
                          </button>
                        )}
                      </div>
                    </div>

                    <div style={{ color: '#f59e0b', fontSize: '1.1rem', marginBottom: '8px' }}>
                      {renderStars(rev.rating)}
                    </div>

                    <p style={{ color: '#4b5563', fontSize: '0.95rem', margin: 0, lineHeight: '1.5' }}>
                      {rev.comment}
                    </p>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

      </div>

      {/* ALT ALAN: YÖNETİCİ GİRİŞ / ÇIKIŞ BUTONU */}
      <div style={{ marginTop: '50px', textAlign: 'center', borderTop: '1px dashed #ddd', paddingTop: '20px' }}>
        {isAdmin ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
            <span style={{ color: '#16a34a', fontWeight: '600', fontSize: '0.9rem' }}>● Yönetici Modu Aktif</span>
            <button
              onClick={handleAdminLogout}
              style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc', backgroundColor: '#fff', cursor: 'pointer', fontSize: '0.85rem' }}
            >
              Çıkış Yap
            </button>
          </div>
        ) : (
          <button
            onClick={() => setShowAdminModal(true)}
            style={{ border: 'none', backgroundColor: 'transparent', color: '#9ca3af', cursor: 'pointer', fontSize: '0.8rem' }}
          >
            Yönetici Girişi
          </button>
        )}
      </div>

      {/* YÖNETİCİ GİRİŞ MODALI */}
      {showAdminModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '12px', width: '300px', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
            <h4 style={{ margin: '0 0 20px 0', textAlign: 'center' }}>Yönetici Girişi</h4>
            <form onSubmit={handleAdminLogin} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <input
                type="email"
                placeholder="E-posta"
                value={adminEmail}
                onChange={(e) => setAdminEmail(e.target.value)}
                required
                style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
              />
              <input
                type="password"
                placeholder="Şifre"
                value={adminPassword}
                onChange={(e) => setAdminPassword(e.target.value)}
                required
                style={{ padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
              />
              <button type="submit" style={{ padding: '10px', borderRadius: '6px', border: 'none', backgroundColor: '#2563eb', color: '#fff', fontWeight: 'bold', cursor: 'pointer' }}>
                Giriş Yap
              </button>
              <button type="button" onClick={() => setShowAdminModal(false)} style={{ padding: '8px', borderRadius: '6px', border: 'none', backgroundColor: '#e5e7eb', cursor: 'pointer' }}>
                İptal
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reviews;